export default function SectionHeader({ eyebrow, title, intro, align = "left" }) {
  const alignClass = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignClass} mb-12`}>
      {eyebrow && (
        <div className="flex items-center gap-3 mb-4">
          <div className="flag-rule"><span /><span /><span /></div>
          <span className="text-xs uppercase tracking-[0.22em] font-bold text-accent">
            {eyebrow}
          </span>
        </div>
      )}
      <h2 className="font-serif text-4xl md:text-5xl font-bold text-primary leading-tight tracking-tight">
        {title}
      </h2>
      {intro && (
        <p className="mt-5 text-base md:text-lg text-muted-foreground leading-relaxed">
          {intro}
        </p>
      )}
    </div>
  );
}
